/* Tradesman Nutrition cart drawer presentation and single-supply upsell choices.
   Native theme cart events own quantity, removal and checkout. The upsell app
   still owns pricing and Add; only its supported 30-day choices are exposed. */
(function () {
  "use strict";

  if (window.__tnCartDrawerLoaded) return;
  window.__tnCartDrawerLoaded = true;

  var ROOT_SELECTOR = "cart-drawer-component.tn-cart-drawer";
  var ROW_SELECTOR = ".cart-items__table-row[data-key]";
  var CLASS = {
    ready: "tn-cart-drawer__ready",
    enhancing: "tn-cart-drawer__enhancing",
    content: "tn-cart-drawer__item-content",
    header: "tn-cart-drawer__item-header",
    meta: "tn-cart-drawer__item-meta",
    plan: "tn-cart-drawer__item-plan",
    actions: "tn-cart-drawer__item-actions",
    hasVariant: "tn-cart-drawer__has-variant",
    hasBadge: "tn-cart-drawer__has-badge",
    hasPlan: "tn-cart-drawer__has-plan",
    hasPrice: "tn-cart-drawer__has-price",
  };

  var PRODUCT_BADGES = {
    shred: "Burns Fat",
    "energy-drink": "Clean Energy",
    sleep: "Deeper Sleep",
    creatine: "Boosts Strength",
    "t-fuel": "Improves Libido",
    "ultimate-blue-collar-stack": "Boosts strength",
    "guaranteed-weight-loss-stack": "Burns Fat",
    "shaker-bottle": "700mL Bottle",
    "training-plan-e-book": "Build Muscle",
    "meal-plan-e-book": "Lose Fat",
    "electric-whisk": "Effortless Mixing",
    "meal-replacement-shake": "No Gym, No Diet",
  };

  // Spanish badge labels. Consulted only when the document is in Spanish, which
  // Shopify sets exclusively on /es/ URLs, so the English cart is untouched.
  var PRODUCT_BADGES_ES = {
    shred: "Quema grasa",
    "energy-drink": "Energía limpia",
    sleep: "Sueño profundo",
    creatine: "Más fuerza",
    "t-fuel": "Mejora la libido",
    "ultimate-blue-collar-stack": "Más fuerza",
    "guaranteed-weight-loss-stack": "Quema grasa",
    "shaker-bottle": "Botella de 700 ml",
    "training-plan-e-book": "Construye músculo",
    "meal-plan-e-book": "Baja grasa",
    "electric-whisk": "Mezcla sin grumos",
    "meal-replacement-shake": "Sin gimnasio, sin dieta",
  };

  function badgeFor(handle) {
    var lang = (
      document.documentElement.getAttribute("lang") || ""
    ).toLowerCase();
    if (lang.indexOf("es") === 0 && PRODUCT_BADGES_ES[handle]) {
      return PRODUCT_BADGES_ES[handle];
    }
    return PRODUCT_BADGES[handle] || "";
  }

  var drawerObserver;
  var observedDrawer;
  var refreshFrame;

  function cssContent(value) {
    var text = String(value || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) return "none";
    return '"' + text.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"';
  }

  function productHandle(row) {
    var title = row.querySelector(".cart-items__title");
    var href = title ? title.getAttribute("href") || "" : "";
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function variantLabel(row) {
    return Array.from(row.querySelectorAll(".cart-items__variants dd"))
      .map(function (item) {
        return (item.textContent || "").replace(/\s+/g, " ").trim();
      })
      .filter(Boolean)
      .join(", ");
  }

  function priceLabel(row) {
    var price = row.querySelector(".cartItemPrice");
    return (price ? price.getAttribute("value") || price.textContent || "" : "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function syncItem(row) {
    var content = row.querySelector("." + CLASS.content);
    if (!content) return;

    var variant = variantLabel(row);
    var badge = badgeFor(productHandle(row));
    var price = priceLabel(row);
    var planContainer = content.querySelector("." + CLASS.plan);
    var plan = row.querySelector(".cart-items__purchase-plan");

    if (plan && planContainer && plan.parentElement !== planContainer) {
      planContainer.appendChild(plan);
    }

    var planLabel = plan
      ? (plan.textContent || "").replace(/\s+/g, " ").trim()
      : "";

    content.style.setProperty("--tn-cart-drawer-variant", cssContent(variant));
    content.style.setProperty("--tn-cart-drawer-badge", cssContent(badge));
    content.style.setProperty("--tn-cart-drawer-price", cssContent(price));
    content.classList.toggle(CLASS.hasVariant, Boolean(variant));
    content.classList.toggle(CLASS.hasBadge, Boolean(badge));
    content.classList.toggle(CLASS.hasPlan, Boolean(planLabel));
    content.classList.toggle(CLASS.hasPrice, Boolean(price));
  }

  function enhanceItem(row) {
    if (!row || row.classList.contains(CLASS.enhancing)) return;

    if (row.classList.contains(CLASS.ready)) {
      syncItem(row);
      return;
    }

    var details = row.querySelector(".cart-items__details");
    if (!details) return;

    row.classList.add(CLASS.enhancing);

    var content = document.createElement("div");
    content.className = CLASS.content;
    content.innerHTML =
      '<div class="' +
      CLASS.header +
      '"></div>' +
      '<div class="' +
      CLASS.meta +
      '" aria-hidden="true"></div>' +
      '<div class="' +
      CLASS.plan +
      '"></div>' +
      '<div class="' +
      CLASS.actions +
      '"></div>';

    details.appendChild(content);

    var header = content.querySelector("." + CLASS.header);
    var actions = content.querySelector("." + CLASS.actions);
    var titleElement = details.querySelector(".cart-items__title");
    var title = titleElement ? titleElement.closest("p") : null;
    var quantity = row.querySelector(
      ".cart-items__quantity cart-quantity-selector-component, .cart-items__quantity .quantity-selector",
    );
    var remove = details.querySelector(".cart-items__remove");

    if (title) header.appendChild(title);
    if (quantity) actions.appendChild(quantity);
    if (remove) actions.appendChild(remove);

    row.classList.add(CLASS.ready);
    row.classList.remove(CLASS.enhancing);
    syncItem(row);
  }

  function sortPrice(row) {
    var price = Number(row.dataset.sortPrice);
    return Number.isFinite(price) ? price : 0;
  }

  function sortPosition(row, fallback) {
    var position = Number(row.dataset.sortPosition);
    return Number.isFinite(position) ? position : fallback;
  }

  function sortItemTable(tableBody) {
    var rows = Array.from(
      tableBody.querySelectorAll(":scope > " + ROW_SELECTOR),
    );
    if (rows.length < 2) return;

    var groups = [];
    var groupsByKey = new Map();
    var nestedRows = [];

    rows.forEach(function (row, index) {
      var parentKey = row.dataset.parentKey || "";

      if (parentKey) {
        nestedRows.push({ row: row, index: index, parentKey: parentKey });
        return;
      }

      var group = {
        rows: [row],
        price: sortPrice(row),
        position: sortPosition(row, index),
      };

      groups.push(group);
      if (row.dataset.key) groupsByKey.set(row.dataset.key, group);
    });

    nestedRows.forEach(function (entry) {
      var parentGroup = groupsByKey.get(entry.parentKey);

      if (parentGroup) {
        parentGroup.rows.push(entry.row);
        return;
      }

      groups.push({
        rows: [entry.row],
        price: sortPrice(entry.row),
        position: sortPosition(entry.row, entry.index),
      });
    });

    groups.forEach(function (group) {
      group.rows.sort(function (a, b) {
        return sortPosition(a, 0) - sortPosition(b, 0);
      });
    });

    groups.sort(function (a, b) {
      return b.price - a.price || a.position - b.position;
    });

    var sortedRows = groups.flatMap(function (group) {
      return group.rows;
    });
    var alreadySorted = rows.every(function (row, index) {
      return row === sortedRows[index];
    });

    if (alreadySorted) return;

    var fragment = document.createDocumentFragment();
    sortedRows.forEach(function (row) {
      fragment.appendChild(row);
    });
    tableBody.appendChild(fragment);
  }

  function sortItems(drawer) {
    drawer
      .querySelectorAll(".cart-items__table > tbody")
      .forEach(sortItemTable);
  }

  function syncCheckout(drawer) {
    var wrapper = drawer ? drawer.querySelector(".checkout-btn-wrapper") : null;
    var checkoutText = wrapper ? wrapper.querySelector(".checkout-text") : null;
    var text = checkoutText ? checkoutText.textContent || "" : "";
    var match = text
      .replace(/\s+/g, " ")
      .trim()
      .match(/CHECKOUT\s*-\s*(.+)$/i);

    if (wrapper) {
      wrapper.style.setProperty(
        "--tn-cart-drawer-checkout-total",
        cssContent(match ? match[1] : ""),
      );
    }
  }

  var UPSELL_ES = {
    "Complete the stack": "Completa el pack",
    Add: "Agregar",
    Added: "Agregado",
    Adding: "Agregando",
  };

  function isSpanishDoc() {
    return (
      (document.documentElement.getAttribute("lang") || "")
        .toLowerCase()
        .indexOf("es") === 0
    );
  }

  function localiseUpsell(root) {
    var scopes = (root || document).querySelectorAll(
      '[data-essential-upsell-element="title"],[data-essential-upsell-element="add-to-cart-button"]',
    );
    Array.prototype.forEach.call(scopes, function (scope) {
      var leaves = scope.querySelectorAll("*");
      var targets = leaves.length ? leaves : [scope];
      Array.prototype.forEach.call(targets, function (el) {
        if (el.children.length) return;
        var key = (el.textContent || "").trim();
        // Only ever rewrites a known ENGLISH key, so a second pass is a no-op.
        // That idempotence is what stops this fighting the MutationObserver.
        if (UPSELL_ES[key]) el.textContent = UPSELL_ES[key];
      });
    });
  }

  var upsellTimer;

  var UPSELL_CARD_SELECTOR =
    '.essential-upsell-cart-portal [data-essential-upsell-element="product"]';
  var UPSELL_SELECT_SELECTOR =
    '[data-essential-upsell-element="variant-select"] select';
  var SUPPLY_LABEL =
    /\b(\d+)\s*[-–]?\s*(?:day(?:s)?\s+supply|d[ií]as?\s+de\s+suministro)\b/i;
  var upsellOptions = new WeakMap();
  var upsellButtons = new WeakMap();
  var upsellFilterTimer;

  function optionSource(option) {
    var source = upsellOptions.get(option);
    var label = option.textContent || "";
    if (!source || source.value !== option.value) {
      if (source && source.filtered) {
        if (option.disabled) option.disabled = source.disabled;
        if (option.hidden) option.hidden = source.hidden;
      }
      source = {
        value: option.value,
        label: label,
        output: label,
        disabled: option.disabled,
        hidden: option.hidden,
        filtered: false,
      };
      upsellOptions.set(option, source);
    } else if (label !== source.output) {
      // React can reuse an option node while replacing its translated label.
      source.label = label;
      source.output = label;
    }
    return source;
  }

  function flavorLabel(label) {
    return label
      .replace(SUPPLY_LABEL, "")
      .replace(/^[\s/|·–-]+|[\s/|·–-]+$/g, "")
      .trim();
  }

  function writeOptionLabel(option, source, label) {
    if (option.textContent !== label) option.textContent = label;
    source.output = label;
  }

  function filterUpsellSelect(select) {
    var options = Array.from(select.options).map(function (option) {
      var source = optionSource(option);
      var match = source.label.match(SUPPLY_LABEL);
      return {
        option: option,
        source: source,
        days: match ? Number(match[1]) : null,
      };
    });
    var applies = options.some(function (entry) {
      return entry.days !== null;
    });
    if (!applies) {
      options.forEach(function (entry) {
        if (entry.source.filtered) {
          entry.option.disabled = entry.source.disabled;
          entry.option.hidden = entry.source.hidden;
          entry.source.filtered = false;
        }
        writeOptionLabel(entry.option, entry.source, entry.source.label);
      });
      return { applies: false, safe: true };
    }

    var selected = options.find(function (entry) {
      return entry.option.value === select.value;
    });
    var selectedFlavor = selected
      ? flavorLabel(selected.source.label).toLowerCase()
      : "";
    var allowed = options.filter(function (entry) {
      return entry.days === 30;
    });
    options.forEach(function (entry) {
      if (entry.days !== 30) {
        if (!entry.option.disabled) entry.option.disabled = true;
        if (!entry.option.hidden) entry.option.hidden = true;
        entry.source.filtered = true;
        return;
      }
      if (entry.source.filtered) {
        entry.option.disabled = entry.source.disabled;
        entry.option.hidden = entry.source.hidden;
        entry.source.filtered = false;
      }
      var label = flavorLabel(entry.source.label) || entry.source.label;
      writeOptionLabel(entry.option, entry.source, label);
    });

    if (!selected || selected.days !== 30) {
      var available = allowed.filter(function (entry) {
        return !entry.option.disabled && !entry.option.hidden;
      });
      var replacement =
        available.find(function (entry) {
          return (
            flavorLabel(entry.source.label).toLowerCase() === selectedFlavor
          );
        }) || available[0];
      if (replacement && select.value !== replacement.option.value) {
        select.value = replacement.option.value;
        // Update the app's selected variant, price and Add handler together.
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    selected = allowed.find(function (entry) {
      return entry.option.value === select.value;
    });
    var container = select.closest(
      '[data-essential-upsell-element="variant-select"]',
    );
    var caption = container
      ? container.querySelector('[data-essential-upsell-element="value"]')
      : null;
    var safe = Boolean(
      selected &&
      !select.disabled &&
      !selected.option.disabled &&
      !selected.option.hidden,
    );
    var drawer = select.closest(ROOT_SELECTOR);
    var unavailable = drawer
      ? drawer.getAttribute("data-upsell-unavailable")
      : "";
    var captionLabel = safe
      ? selected.option.textContent
      : unavailable || "Unavailable";
    if (caption && caption.textContent !== captionLabel)
      caption.textContent = captionLabel;
    return {
      applies: true,
      safe: safe,
      value: select.value,
    };
  }

  function setUpsellBlocked(button, blocked) {
    var source = upsellButtons.get(button);
    if (blocked) {
      if (!source) {
        source = { ariaDisabled: button.getAttribute("aria-disabled") };
        upsellButtons.set(button, source);
      }
      if (!button.hasAttribute("data-tn-upsell-blocked"))
        button.setAttribute("data-tn-upsell-blocked", "");
      if (button.getAttribute("aria-disabled") !== "true")
        button.setAttribute("aria-disabled", "true");
    } else if (source) {
      button.removeAttribute("data-tn-upsell-blocked");
      if (button.getAttribute("aria-disabled") === "true") {
        if (source.ariaDisabled === null)
          button.removeAttribute("aria-disabled");
        else button.setAttribute("aria-disabled", source.ariaDisabled);
      }
      upsellButtons.delete(button);
    }
  }

  function filterUpsellCard(card) {
    var applies = false;
    var safe = true;
    card.querySelectorAll(UPSELL_SELECT_SELECTOR).forEach(function (select) {
      var result = filterUpsellSelect(select);
      if (!result.applies) return;
      applies = true;
      var prices = Array.from(
        card.querySelectorAll(
          '[data-essential-upsell-element="price"] [data-variant-id]',
        ),
      );
      // The app can render its price after the select. Wait for both to agree.
      var synchronized =
        prices.length > 0 &&
        prices.every(function (price) {
          return price.getAttribute("data-variant-id") === result.value;
        });
      safe = safe && result.safe && synchronized;
    });
    card
      .querySelectorAll('[data-essential-upsell-element="add-to-cart-button"]')
      .forEach(function (button) {
        setUpsellBlocked(button, applies && !safe);
      });
    return { applies: applies, safe: safe };
  }

  function filterUpsells(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll(UPSELL_CARD_SELECTOR).forEach(filterUpsellCard);
  }

  function scheduleUpsellFilter() {
    if (upsellFilterTimer) return;
    upsellFilterTimer = setTimeout(function () {
      upsellFilterTimer = 0;
      if (observedDrawer && observedDrawer.isConnected)
        filterUpsells(observedDrawer);
    }, 0);
  }

  function protectUpsellAdd(event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest(
      '[data-essential-upsell-element="add-to-cart-button"]',
    );
    var card = button ? button.closest(UPSELL_CARD_SELECTOR) : null;
    if (!card || !card.closest(ROOT_SELECTOR)) return;
    var result = filterUpsellCard(card);
    if (result.applies && !result.safe) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function scheduleUpsellLocalise() {
    // setTimeout, not requestAnimationFrame: rAF never fires while the tab is
    // hidden, so a backgrounded cart would stay in English until refocused.
    if (upsellTimer) return;
    upsellTimer = setTimeout(function () {
      upsellTimer = 0;
      localiseUpsell(document);
    }, 0);
  }

  function startUpsellLocaliser() {
    // The upsell app mounts asynchronously, after the drawer has settled, so this
    // needs its own observer rather than riding on enhanceDrawer().
    // Gated on Spanish: on an English page nothing is observed and nothing runs.
    if (!isSpanishDoc()) return;
    scheduleUpsellLocalise();
    new MutationObserver(scheduleUpsellLocalise).observe(
      document.documentElement,
      { childList: true, subtree: true },
    );
  }

  function enhanceDrawer(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll(ROW_SELECTOR).forEach(enhanceItem);
    sortItems(drawer);
    syncCheckout(drawer);
    filterUpsells(drawer);
  }

  function rowsWithin(node, rows) {
    if (!(node instanceof Element)) return;
    if (node.matches(ROW_SELECTOR)) rows.add(node);
    node.querySelectorAll(ROW_SELECTOR).forEach(function (row) {
      rows.add(row);
    });
  }

  function handleDrawerMutations(mutations) {
    if (!observedDrawer || !observedDrawer.isConnected) return;
    var rows = new Set();

    mutations.forEach(function (mutation) {
      var parent = mutation.target.parentElement;
      var ownerRow = parent ? parent.closest(ROW_SELECTOR) : null;
      if (ownerRow) rows.add(ownerRow);

      mutation.addedNodes.forEach(function (node) {
        rowsWithin(node, rows);
      });
    });

    rows.forEach(enhanceItem);
    sortItems(observedDrawer);
    syncCheckout(observedDrawer);
    scheduleUpsellFilter();
  }

  function bindDrawer() {
    var drawer = document.querySelector(ROOT_SELECTOR);
    if (!drawer) return;

    if (drawer !== observedDrawer) {
      if (drawerObserver) drawerObserver.disconnect();
      observedDrawer = drawer;
      drawerObserver = new MutationObserver(handleDrawerMutations);
      drawerObserver.observe(drawer, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["value", "disabled", "hidden", "data-variant-id"],
      });
    }

    enhanceDrawer(drawer);
  }

  function scheduleRefresh() {
    if (refreshFrame) cancelAnimationFrame(refreshFrame);
    refreshFrame = requestAnimationFrame(function () {
      refreshFrame = requestAnimationFrame(function () {
        refreshFrame = 0;
        bindDrawer();
      });
    });
  }

  function init() {
    bindDrawer();
    startUpsellLocaliser();
    document.addEventListener("cart:update", scheduleRefresh);
    document.addEventListener("cart:refresh", scheduleRefresh);
    document.addEventListener("shopify:section:load", bindDrawer);
    document.addEventListener("shopify:section:unload", function (event) {
      if (
        !(event.target instanceof Element) ||
        !observedDrawer ||
        !event.target.contains(observedDrawer)
      )
        return;
      if (drawerObserver) drawerObserver.disconnect();
      observedDrawer = null;
      if (upsellFilterTimer) clearTimeout(upsellFilterTimer);
      upsellFilterTimer = 0;
    });
    document.addEventListener("click", protectUpsellAdd, true);
    document.addEventListener(
      "change",
      function (event) {
        if (
          event.target instanceof Element &&
          event.target.matches(UPSELL_SELECT_SELECTOR) &&
          event.target.closest(ROOT_SELECTOR)
        ) {
          scheduleUpsellFilter();
        }
      },
      true,
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
